import { render, staticRenderFns } from "./saveOrUpdateSysStudentDo.vue?vue&type=template&id=a6ab7dba&scoped=true&"
import script from "./saveOrUpdateSysStudentDo.vue?vue&type=script&lang=js&"
export * from "./saveOrUpdateSysStudentDo.vue?vue&type=script&lang=js&"
import style0 from "./saveOrUpdateSysStudentDo.vue?vue&type=style&index=0&id=a6ab7dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ab7dba",
  null
  
)

export default component.exports